import { createBrowserRouter } from 'react-router-dom';
import { createWebsiteRoutes } from '@/website/routes.tsx';
import { createPortalRoutes } from '@/portal/routes.tsx';

const createRouter = () => {
  return createBrowserRouter(
    [...createWebsiteRoutes(), ...createPortalRoutes()],
    {
      future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: false,
        v7_skipActionErrorRevalidation: true,
      },
    }
  );
};

export default createRouter;
